import { ReactNode } from 'react';

import { DatetimeShow } from '@fhs/ui';

import { thanksgivingSubCAEndDate, thanksgivingSubCAStartDate } from '../constants';

export type LtoContentCAProps = {
  default?: ReactNode;
  thanksgivingSub: ReactNode;
};

export const LtoContentCA = ({ thanksgivingSub, default: defaultContent }: LtoContentCAProps) => {
  return (
    <DatetimeShow
      after={thanksgivingSubCAStartDate}
      before={thanksgivingSubCAEndDate}
      default={defaultContent}
    >
      {thanksgivingSub}
    </DatetimeShow>
  );
};
